// extracted by mini-css-extract-plugin
export default {"workoutTable":"ML29RfJqngI9B47zr0tz"};